namespace SP.Data {


    export class Transfer {


        static async getPackageTransferInfo(scan_data: string): Promise<PackageTransferInfo> {
            var response = await SP.post<any>("/api/v1/transfer/info/", encodeURIComponent(scan_data));
            if (response.status == 200) return response.data as PackageTransferInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getPackageTransferInfos(): Promise<PackageTransferInfo[]> {
            var response = await SP.get<any>("/api/v1/transfer/list/");
            if (response.status == 200) return response.data as PackageTransferInfo[];
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

    }
}